import { mountVendorWindowEvent } from '../../mountVendorWindowEvent';

import type { PeacockEvent, PeacockApi } from './types';

export interface TrackPeacockEventArgs {
  name: PeacockEvent;
}

declare global {
  interface Window {
    pubSuite?: PeacockApi;
  }
}

function _mountPeacockEvent(w: Window, { name }: TrackPeacockEventArgs) {
  w.pubSuite?.sendConversion(name);
}

export const mountPeacockEvent = mountVendorWindowEvent(
  'Peacock',
  _mountPeacockEvent
);
